import * as React from 'react';
import { getToken } from '@workiva/unify-tokens';

import fileListItemClasses from 'src/components/FileListItem/fileListItemClasses';
import type {
  FileModel,
  FileLike,
} from 'src/components/FileUploader/fileModel';
import {
  ListItemText,
  type ListItemTextProps,
} from 'src/components/ListItemText';

export type FileListItemTextOwnProps = {
  fileName: FileLike['name'];
  errors: NonNullable<FileModel['errors']>;
};

export type FileListItemTextProps = ListItemTextProps &
  FileListItemTextOwnProps;

export function FileListItemText(
  props: FileListItemTextProps
): React.ReactElement | null {
  const {
    primaryTypographyProps: primaryTypographyPropsProp = {},
    secondaryTypographyProps: secondaryTypographyPropsProp = {},
    errors,
    fileName,
    ...rest
  } = props;

  return (
    <ListItemText
      {...rest}
      primary={fileName}
      primaryTypographyProps={{
        variant: 'h6',
        noWrap: true,
        className: fileListItemClasses.fileName,
        ...primaryTypographyPropsProp,
      }}
      secondary={
        errors.length === 0
          ? undefined
          : errors.map((err, index) => (
              <div key={`error-message-${index}`}>{err.message}</div>
            ))
      }
      secondaryTypographyProps={{
        variant: 'caption',
        color: getToken('Core/Text/text-error'),
        className: fileListItemClasses.fileErrorMessage,
        ...secondaryTypographyPropsProp,
      }}
    />
  );
}

export default FileListItemText;
